"use strict";
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ToolTipContainer = styled_components_1.default.div `
  border-radius: ${({ theme }) => theme.radius};
  border: 1px solid grey;
  box-shadow: ${({ theme }) => theme.boxShadows.standard};
  background: ${({ theme }) => theme.toolTip.background};
  align-items: center;
  position: absolute;
  padding: 5px 10px;
  z-index: 2;
  display: ${(props) => (props.show ? "block" : "none")};
`;
function ToolTip({ show, position, content, style }) {
    const defaultStyles = {
        top: (position === null || position === void 0 ? void 0 : position.y) + "px",
        left: (position === null || position === void 0 ? void 0 : position.x) + "px",
    };
    const mergedStyles = { ...defaultStyles, ...style };
    return (react_1.default.createElement(ToolTipContainer, { show: show, style: mergedStyles }, content));
}
exports.default = ToolTip;
//# sourceMappingURL=index.js.map